import { render, staticRenderFns } from "./the-notification-bar.vue?vue&type=template&id=dca97a46&"
import script from "./the-notification-bar.vue?vue&type=script&lang=js&"
export * from "./the-notification-bar.vue?vue&type=script&lang=js&"
import style0 from "./the-notification-bar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports